export class StringUtils {
  static parse = (str: string, toCall: unknown[]) => {
    const args = [].slice.call(toCall, 0)
    let i = 0

    return str.replace(/%s/g, () => args[i++])
  }

  static equalsFacetsValue = (valueA: string, valueB: string) => {
    const nA = decodeURIComponent(valueA)
      .replace(/\s/g, '')
      .replace(/\+or\+/g, ',')
      .replace(/or/g, ',')
    const nB = decodeURIComponent(valueB)
      .replace(/\s/g, '')
      .replace(/\+or\+/g, ',')
      .replace(/or/g, ',')

    return nA === nB
  }

  static titleCase = (str: string) => {
    return str
      ?.toLowerCase()
      ?.split(' ')
      ?.map((word) => word?.replace(word[0], word[0]?.toUpperCase()))
      ?.join(' ')
  }

  static capitalize = (str: string) => {
    if (!str) return ''
    const allLower = str.toLowerCase()
    return allLower.charAt(0).toUpperCase() + allLower.slice(1)
  }
}
